export class TeacherDetailedList {
  static readonly type = '[teacherList] get';
  constructor(public teacherData: any) {}
}

export class removeTeacherList {
  static readonly type = '[removeTeacherList] remove';
}
